<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" v-bind:class="className">
      <div class="modal-overlay" @click="back()"></div>
      <div class="modal">
        <article v-if="resource">

          <header>
            <figure><i class="icon icon-icon_layers"></i></figure>
            <div>
              <span class="breadcrumb">
                  Facture <i class="icon icon-icon_arrow-right"></i> New
              </span>
              <h1>{{ resource.reference }}</h1>
            </div>
            <div class="spacer"></div>
            <div class="buttons">
              <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
              <button @click="print()" class="bt-print"><span><i class="icon icon-printer"></i></span></button>
              <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span>
              </button>
            </div>

            <div style="width: 100%;background: #ebedf3;padding: 10px;font-weight: 600;margin-bottom: 10px;display: flex;align-items: center;" v-if="!edition_mode">
              <div v-if="is_readonly"><i class="icon icon-icon_lock"></i> Cette commande est verouillée</div>
              <div v-if="!is_readonly"><i class="icon icon-icon_lock-open"></i> Cette commande est verouillée, mais peut être éditée</div>
              <div v-if="!is_readonly" style="margin-left: auto;font-size:12px;font-weight:400;background: #fff;padding: 5px 10px;cursor: pointer;" @click="activeEditionMode">Déverouiller maintenant</div>
            </div>
          </header>


          <tabs :options="{ useUrlFragment: false }">
            <tab name="Détail du client">

              <form-scopes label='Scopes' v-model="resource"></form-scopes>
              <form-checklist :label="'Paiement'" v-model="resource.new_payment_status" :options="statuses"
                              multiple="false"></form-checklist>
              <form-select label="Mode de paiement" multiple="false" v-model="payment"
                           :default="resource.invoice_payment_id" :options="payments"></form-select>

              <fieldset>
                <h3>Information</h3>
                <p class="headline"></p>
                <!-- BRANCH -->
                <form-text label="Reference" v-model="resource.reference" :disabled="true"></form-text>
                <form-select label="Conditions de paiement" multiple="false" v-model="resource.payment_condition"
                             :default="resource.payment_condition"
                             :options="$store.getters.scope.payment_conditions"
                             :disabled="!edition_mode"></form-select>
                <form-select label="Succursale" multiple="false" v-model="resource.branch" :default="branch_id"
                             :options="branches"></form-select>
                <form-datex label="Date" v-model="resource.invoiced_at" :hide-time="true" :disabled="!edition_mode"></form-datex>
                <form-autocomplete label="Personne en charge" multiple="false" v-model="resource.user"
                                   :default="resource.user_id" :service="userService"
                                   icon="icon-icon_person"></form-autocomplete>
              </fieldset>

              <fieldset>
                <h3>Client</h3>
                <p class="headline"></p>

                <entity v-model="entity" :default="resource.client_id" :default-type="resource.client_type"
                        :callback="updateEntity" :create="true" :show-company="false" :show-detail="true" :disabled="!edition_mode"></entity>

                <form-select label="Langue" multiple="false" v-model="resource.locale" :default="language"
                             :options="$store.state.locales"></form-select>

                <div class="address">

                  <form-address
                      label="Facturation"
                      v-model="resource.address_billing"
                      :options="addresses"
                      :disabled="!edition_mode"></form-address>

                </div>
              </fieldset>

            </tab>
            <tab name="Options avancées">

              <form-text label="Titre" v-model="resource.title" :disabled="!edition_mode"></form-text>
              <form-text label="Sous-titre" v-model="resource.subtitle" :disabled="!edition_mode"></form-text>
              <form-text label="Purchase Number" v-model="resource.purchase_number" :disabled="!edition_mode"></form-text>
              <form-textarea label="Commentaire facture" v-model="resource.comments_invoice" :disabled="!edition_mode"></form-textarea>

            </tab>
            <tab name="Détail de la facture">



              <fieldset>
                <h3>Détail de la facture</h3>
                <p class="headline"></p>

                <button @click="print()">Exporter en PDF</button>

                <div class="invoice">
                  <div>

                    <invoice v-model="resource.invoice"
                             :title="resource.invoice_title"
                             :subtitle="resource.invoice_subtitle"
                             :date="resource.invoiced_at"></invoice>

                  </div>
                </div>
              </fieldset>

            </tab>
          </tabs>
        </article>

      </div>
    </div>
  </transition>
</template>
<script>

import InvoiceService from './InvoiceService.js';
import Edit from '../../../layouts/Edit.vue';
import ProductService from '../../shop/product/ProductService.js';

import PaymentService from '../../config/payment/PaymentService.js';
import ShippingService from '../../shop/shipping/ShippingService.js';
import VoucherService from '../../shop/voucher/VoucherService.js';

import UserService from '../../scope/UserService.js';
import PersonService from '../../person/PersonService.js';
import CompanyService from '../../company/CompanyService.js';
import BranchService from "../../config/branch/BranchService";

export default {
  extends: Edit,
  data() {
    return {
      factor: 0.05,
      locale: null,
      voucher: null,
      shipping: null,
      payment: null,
      shipping_id: null,
      invoice_payment_id: null,
      payments: [],
      branches: [],
      shippingListing: [],
      productService: null,
      voucherService: null,
      userService: null,
      product: null,
      price: null,
      currency: null,
      entity: null,
      invoice: [],
      branch_id: null,
      invoice_subtotal: 0,
      invoice_shipping: 0,
      invoice_taxes: 0,
      invoice_total: 0,
      addresses: [],
      types: [
        {id: 'person', name: 'Individu'},
        {id: 'company', name: 'Entreprise'}
      ],
      rabais: [
        {id: 0, name: '-'},
        {id: 5, name: '5%'},
        {id: 10, name: '10%'},
        {id: 15, name: '15%'},
        {id: 20, name: '20%'},
        {id: 25, name: '25%'},
      ],
      statuses: [
        {id: 'draft', name: 'Brouillon', color: '#888888'},
        {id: 'pending', name: 'En attente', color: '#f4b406'},
        {id: 'completed', name: 'Payé', color: '#46994e'},
        {id: 'canceled', name: 'Annulé', color: '#ba2766'}
      ],
      client_type_id: "",
      updateSubtotalDebounce: null,
      language: null,
      edition_mode: false,
      is_readonly: true
    }
  },
  mounted: function () {

    this.currency = this.$store.state.scope.currency_id
    this.price = 'HT'

    this.productService = ProductService;
    this.voucherService = VoucherService;
    this.userService = UserService;

    this.resource.locale = 'fr'
    this.resource.has_taxes = true

    this.countries = {}
    for (let item of this.$store.state.countries) {
      this.countries[item.id] = item
    }

    BranchService.query().then(response => {
      this.branches = response.data.data
      this.isLoading = false
    })


  },
  methods: {
    newEntity: function () {
      console.log('NEW ENTITY');
    },
    print: function () {
      window.open(this.resource.download_link, 'Download Invoice');
    },
    addProductLine: function (item) {

      let found = false;

      for (let line of this.invoice) {
        if (line.id == item.id && line.id != null) {
          line.quantity += 1;
          found = true;
        }
      }

      if (!found) {

        let quantity = item.quantity ? parseInt(item.quantity) : 1
        let price_ht = item.calculation ? item.calculation.ht : item.price.ht
        let price_ttc = item.calculation ? item.calculation.ttc : item.price.ttc
        let price_base_ht = item.calculation ? item.calculation.base_ht : price_ht
        let price_base_ttc = item.calculation ? item.calculation.base_ttc : price_ttc
        let tax = item.calculation ? item.calculation.tax : item.price.tax
        let has_shipping = item.has_shipping ? item.has_shipping : 1

        this.invoice.push({
          id: item.id,
          name: item.name,
          description: item.description,
          sku: item.sku,
          ean: item.ean,
          picture: item.picture,
          quantity: quantity,
          price_manual: ((price_ht - 0) / quantity).toFixed(2),
          price_manual_with_voucher: ((price_ht - 0) / quantity).toFixed(2),
          price: {
            ht: price_base_ht - 0,
            ttc: price_base_ttc - 0,
            tax: tax
          },
          voucher: this.rabais[0],
          has_shipping: has_shipping
        });
      }

      this.updateSubtotal()
      this.product = null;
    },
    deleteLine: function (index) {
      this.invoice.splice(index, 1)
    },
    addEmptyLine: function () {
      this.invoice.push({
        id: null,
        name: "",
        description: null,
        sku: null,
        ean: null,
        picture: null,
        quantity: 1,
        price_manual: 0,
        price_manual_with_voucher: 0,
        price: {
          ht: 0,
          ttc: 0,
          tax: 7.7
        },
        voucher: this.rabais[0],
        has_shipping: 1
      });

      this.updateSubtotal()
    },
    updateSubtotal: function () {

      let self = this

      //if( this.resource.payment_status != 'draft' || !this.initialized ){ return true; }

      clearInterval(this.updateSubtotalDebounce)

      this.updateSubtotalDebounce = setTimeout(function () {

        for (let item of self.invoice) {
          if (item.voucher && item.voucher.id) {
            item.price_manual_with_voucher = item.price_manual - (item.price_manual * item.voucher.id / 100)
          } else {
            item.price_manual_with_voucher = item.price_manual;
          }
        }

        InvoiceService.calculate({

          has_taxes: self.resource.has_taxes,
          products: self.invoice,
          voucher: self.voucher,
          country: self.country,
          shipping_id: self.shipping_id,
          payment_id: self.invoice_payment_id

        }).then(response => {

          self.resource.amount_shipping = response.data.amount_shipping.toFixed(2)
          self.resource.amount_tax = response.data.amount_tax.toFixed(2)
          self.resource.amount_subtotal = response.data.amount_subtotal.toFixed(2)
          self.resource.amount_total = response.data.amount_total.toFixed(2)
          self.resource.amount_voucher = response.data.amount_voucher.toFixed(2)

          self.resource.detail_total = response.data.detail_total
          self.resource.detail_taxes = response.data.detail_taxes
          self.resource.detail_shipping = response.data.detail_shipping
          self.resource.detail_products = response.data.detail_products
          self.resource.detail_vouchers = response.data.detail_vouchers

          self.$forceUpdate()

        })

      }, 100)

    },
    selectVoucher: function (item) {
      this.voucher_id = item.id
      this.updateSubtotal();
    },
    selectPayment: function (item) {
      this.invoice_payment_id = item.id
      this.updateSubtotal();
    },
    selectShipping: function (item) {
      this.shipping_id = item.id
      this.updateSubtotal();
    },
    updateAddress: function (item) {

      console.log("updateAddress", item, this.resource.address_billing)

    },
    updateEntity: function (item) {

      if (item) {
        this.resource.client_type = item.type
        this.resource.client = item.entity
        this.addresses = item.addresses

        this.resource.email = item.entity.email ? item.entity.email : this.resource.email
        this.resource.phone = item.entity.phone_mobile ? item.entity.phone_mobile : this.resource.phone

        if (item.addresses[0] && (this.resource.address_billing == null || this.resource.address_billing == {})) {
          if (this.resource.id == null) {
            this.resource.address_billing = item.addresses[0]
          }
        }

      }

    },
    setStatus: function (status) {
      this.resource.payment_status = status;
      this.$forceUpdate()
    },
    setShipping: function (item) {
      this.updateSubtotal();
    },
    setTransactionStatus: function (event) {
      let status = event.srcElement.value;
      this.resource.new_payment_status = status
      this.$forceUpdate()
    },
    resourceLoaded: function () {

      var today = new Date()
      this.resource.invoiced_at = this.resource.invoiced_at || today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      this.resource.user_id = this.resource.user_id || this.resource.user_id || null;
      this.language = this.resource.locale || this.resource.locale || 'fr';

      this.resource.detail_shipping = this.resource.detail_shipping || null;
      this.resource.detail_payment = this.resource.detail_payment || null;
      this.resource.detail_products = this.resource.detail_products || [];
      this.resource.detail_vouchers = this.resource.detail_vouchers || [];

      this.resource.new_payment_status = this.resource.payment_status ? this.resource.payment_status : 'draft';
      this.resource.has_taxes = true;
      this.resource.country = 'CH';

      this.is_readonly = this.resource.is_readonly

      this.voucher = this.resource.detail_vouchers[0] ? this.resource.detail_vouchers[0] : null

      this.shipping_id = this.resource.detail_shipping ? this.resource.detail_shipping.id : null
      this.invoice_payment_id = this.resource.invoice_payment_id

      this.shipping = this.resource.detail_shipping
      this.payment = this.resource.detail_payment

      this.branch_id = this.resource.branch_id

      for (let item of this.resource.detail_products) {
        this.addProductLine(item)
      }

      ShippingService.all().then(response => {

        this.shippingListing = response.data;

        this.isLoading = false
        for (let item of response.data) {
          if (item.id == this.resource.shipping_id) {
            this.resource.detail_shipping = item;
            break;
          }
        }
      })


      PaymentService.all().then(response => {
        this.payments = response.data
        this.isLoading = false
        for (let item of response.data) {
          if (item.id == this.resource.invoice_payment_id) {
            this.payment = item;
            break;
          }
        }
      })

      if (this.resource.id == null) {
        this.edition_mode = true;
        this.is_readonly = false;
      }

      this.initialized = true

      this.updateSubtotal()
      this.initialize()
    },
    beforeUpdate: function (Resource) {

      //Resource.locale = Resource.locale && Resource.locale.id ? Resource.locale.id : null;
      //Resource.detail_products = this.invoice;
      Resource.force_edition = this.edition_mode
      Resource.client_type = Resource.client_type instanceof Array ? Resource.client_type[0] : Resource.client_type;

      Resource.detail_shipping = this.shipping ? this.shipping : null
      Resource.detail_payment = this.payment ? this.payment : null

      return true;
    },
    getResource: function () {
      return InvoiceService
    },
    activeEditionMode: function () {
      var allowed_edition = false;
      if (this.resource.id != null && this.resource.new_payment_status !== "completed" && this.resource.is_readonly != true && !this.is_readonly ) {
        this.edition_mode = true;
        this.$forceUpdate();
      } else {
        alert("La facture est verouillée car elle a été payée.")
      }
    }
  },
  watch: {
    'invoice': {
      handler: function (newVal, oldVal) {
        this.updateSubtotal();
      },
      deep: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/invoice/Edit.vue